import {combineReducers} from '@reduxjs/toolkit';
import getReportOptionsReducer from './get-report-options';
import getReportLevelOptionListReducer from './get-report-level-option-list';
import getReportListReducer from './get-report-list';
import exportReportReducer from './export-report';

const reportReducer = combineReducers({
  getReportOptions: getReportOptionsReducer,
  getReportLevelOptionList: getReportLevelOptionListReducer,
  getReportList: getReportListReducer,
  exportReport: exportReportReducer,
});

export default reportReducer;
